import $ from 'jquery';

function setYear() {
    $("footer span#year").text(new Date(Date.now()).getFullYear());
}

export { setYear };